import FormControl from "@mui/material/FormControl";
import React from 'react';
import { Dates } from './Dates';
import { filterContainerStyle } from './Filter.style';
import { Multi } from './Multi';
import { Toggle } from './Toggle';
import { FilterType } from './types';
export const Filter = ({ filterContent: { title, type, label, args }, paginationData, dataQa }) => {
    return (React.createElement(FormControl, { sx: filterContainerStyle },
        type === FilterType.MULTI &&
            React.createElement(Multi, { dataQa: dataQa, filters: args.filters, onSendFilters: args.onSendFilters, title: title, label: label, hasValidation: args.hasValidation, labelActionButton: args.labelActionButton, paginationData: paginationData }),
        type === FilterType.DATES &&
            React.createElement(Dates, { dataQa: dataQa, datesRange: args.datesRange, defaultValue: args.defaultValue, disableFuture: args.disableFuture, onSendDatesRange: args.onSendDatesRange, title: title, label: label, labelsDateFilter: args.labelsDateFilter, maxDate: args.maxDate, minDate: args.minDate, paginationData: paginationData }),
        type === FilterType.TOGGLE &&
            React.createElement(Toggle, { label: label, dataQa: dataQa, onSendFilter: args.onSendFilter, paginationData: paginationData })));
};
